import type { ModelOrderResponse } from '@layup/api-sdk';

export const PAYMENT_PLAN_MERCHANTS = ['TRAVELSTART', 'DREAM RESORTS', 'HOWLER', 'LB FUNCTION'];

export const isPaymentPlanMerchant = (order: ModelOrderResponse) =>
  PAYMENT_PLAN_MERCHANTS.includes(order.merchantName?.toUpperCase() ?? '');
